import { fetcher } from '@weezevent/weezjs-core';

export const downloadFile = async (requestUrl, fileName, fileType = 'text/csv', method = 'GET', body = null, headers = {}) => {
    let options = { method, headers };
    if (body) {
        options['body'] = body;
    }
    let a = null;
    let url = null;
    await fetcher
        .request(requestUrl, options)
        .then(response => {
            const blob = new Blob([response.response], { type: fileType });
            a = document.createElement('a');
            url = window.URL.createObjectURL(blob);
        })
        .catch(err => {
            console.error('An error occurred ', err);
        });
    document.body.appendChild(a);
    a.href = url;
    a.download = fileName;
    a.click();
    setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    }, 0);
};
